import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { TwgExplorerSectionLoadingPlaceholder } from '../src/ui-components/TwgExplorerSectionLoadingPlaceholder.tsx';
import type { TwgExplorerSectionProps } from '../src/TwgExplorerSection.tsx';

export const TwgExplorerSectionLoader: LoadableType<TwgExplorerSectionProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-twg-explorer-section" */ '../src/TwgExplorerSection.tsx'
			)
		).TwgExplorerSection,
	loading: TwgExplorerSectionLoadingPlaceholder,
});
